const CustomFormFields = {
    phone: `
        <label class="uppercase py-0 mb-2.5">Phone number</label>
        <div class="gform-custom-container bg-transparent w-full h-16 py-0 px-3 border border-solid border-black flex gap-2.5 items-center">
            <select class="gform-custom-dropdown">
                <option>+44</option>
            </select>
            <div class="chevy" x-html="MWBIcons.newChev"></div>
            <div class="pipe" x-html="MWBIcons.verticalLine"></div>
            <input placeholder="00 0000 0000" class="gform-custom-input" required/>
        </div></div>`
};

window.CustomFormFields = CustomFormFields;

export default CustomFormFields;